<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    wrapperClass?: HTMLAttributes['class']
    ringClass?: HTMLAttributes['class']
    iconWrapperClass?: HTMLAttributes['class']
    icon?: string
    iconSize?: string
    title?: string
    description?: string
    disableBackgroundStyle?: boolean
    titleClass?: HTMLAttributes['class']
    descriptionClass?: HTMLAttributes['class']
    radialColor?: string
  }>(),
  {
    class: undefined,
    wrapperClass: undefined,
    ringClass: undefined,
    iconWrapperClass: undefined,
    icon: undefined,
    title: undefined,
    description: undefined,
    titleClass: undefined,
    descriptionClass: undefined,
    iconSize: '32px',
    disableBackgroundStyle: false,
    radialColor: 'var(--color-primary)'
  }
)
</script>

<template>
  <div
    :class="
      cn(
        'p-1 overflow-hidden shadow bg-surface-container group relative rounded-2xl select-none',
        props.class
      )
    "
  >
    <slot name="flag" />
    <div
      class="opacity-0 -translate-y-full group-hover:translate-y-0 duration-200 group-hover:opacity-100 absolute inset-0 bg-linear-to-br from-magenta group-hover:to-primary transition-all"
    ></div>
    <div
      :class="
        cn(
          'p-5 h-full flex flex-col gap-3 items-start relative rounded-xl bg-background',
          {
            'items-center': !description && icon
          },
          props.wrapperClass
        )
      "
    >
      <slot>
        <div
          v-if="icon"
          :class="
            cn(
              'p-2 bg-secondary-container text-primary shrink-0 rounded-full overflow-hidden relative',
              iconWrapperClass
            )
          "
        >
          <span
            class="opacity-0 translate-y-full group-hover:translate-y-0 duration-200 rounded-full group-hover:opacity-100 absolute inset-0 bg-linear-to-br from-magenta group-hover:to-primary transition-all"
          ></span>

          <Icon
            class="relative text-primary group-hover:text-on-primary transition-colors duration-200"
            :name="icon"
            :size="iconSize"
          />
        </div>
        <div class="flex flex-col gap-1">
          <h3
            :class="
              cn(
                'font-semibold lg:text-lg',
                {
                  'text-center': !description && icon
                },
                props.titleClass
              )
            "
          >
            {{ title }}
          </h3>
          <p
            v-if="description"
            :class="cn('text-current/70', props.descriptionClass)"
          >
            {{ description }}
          </p>
        </div>
      </slot>
    </div>
  </div>
</template>
